import React from 'react'
import { Box, BoxProps } from '@chakra-ui/react'

import { useMessageProperties } from '../message-provider'
import { useExportMessages } from '~components/chats/chat/export-messages-context'

interface Props extends BoxProps {
    isRight?: boolean
    isLast?: boolean
    isFirst?: boolean
    isAttachment?: boolean
    showLocationTag?: boolean
}

export default function MessageBubble({
    isRight = true,
    isLast = false,
    isFirst = false,
    children,
    isAttachment = false,
    showLocationTag = false,
    ...props
}: Props) {
    const { message } = useMessageProperties()
    const { isExporting } = useExportMessages()

    const isInternal = message.hidden_for_client

    return (
        <Box
            w="fit-content"
            px={3}
            py={2}
            bg={isRight ? (isInternal ? 'orange.100' : 'blue.50') : 'gray.100'}
            color="gray.900"
            borderRadius="xl"
            overflowWrap="anywhere"
            fontSize="sm"
            minW={{ base: '60%', lg: '45%' }}
            opacity={showLocationTag ? 0.7 : 1}
            transition="opacity 0.2s ease-in-out"
            maxW={{
                base: '100%',
                xl: '75%',
            }}
            _hover={
                isExporting
                    ? {}
                    : {
                          opacity: 1,
                          bg: isRight
                              ? isInternal
                                  ? 'orange.200'
                                  : 'blue.100'
                              : 'gray.200',
                      }
            }
            {...props}
        >
            {children}
        </Box>
    )
}
